import { IProductImage } from "@Interfaces/Api/Product";
import Box from "@mui/material/Box";
import { isImage } from "@Services/Helper";
import React, { memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

interface ThumbnailProps {
  media: IProductImage[];
  handleImageToShowChange: Function;
}

function Thumbnail({ media, handleImageToShowChange }: ThumbnailProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        position: "relative",
        height: "60px",
        width: "100%",
      }}
      id="product-detail-thumbnail-carousel"
    >
      <Swiper
        direction="horizontal"
        slidesPerView={5}
        spaceBetween={10}
        navigation={media.length > 4}
        modules={[Navigation]}
      // style={{ height: "100%" }}
      >
        {media.map((item, index) => (
          <SwiperSlide key={index} style={{ maxHeight: "100%" }}>
            <Box
              onClick={() => handleImageToShowChange(item.url)}
              component={isImage(item.url) ? "img" : "video"}
              src={item.url}
              style={{
                width: "75%",
                cursor: "pointer",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}

export default memo(Thumbnail);
